export const themes = ["czr-light","czr-dark","wh-light","wh-dark","czr-palace-light","czr-palace-dark","horseshoe-light","horseshoe-dark"]